export const RPMTabs = (function() {
    'use strict';

    function init() {
        console.log("RPMTabs initialized");
        events();
        tabs();
    }

    function events() {}

    function tabs() {
        const tabButtons = document.querySelectorAll(".tab-button");
        const tabContents = document.querySelectorAll(".tab-content");

        tabButtons.forEach(button => {
            button.addEventListener("click", () => {
                console.log("Tab clicked:", button);
                const tabId = button.getAttribute("data-tab");

                // Remove active class from all tab buttons and contents
                tabButtons.forEach(btn => btn.classList.remove("active"));
                tabContents.forEach(content => content.classList.remove("active"));

                // Add active class to the clicked tab and corresponding content
                button.classList.add("active");
                document.getElementById(tabId).classList.add("active");
            });
        });
    }

    return {
        init: init
    };
})();

document.addEventListener("DOMContentLoaded", RPMTabs.init);